import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import CustomInput from 'component/Input/CustomInputDark';
import CustomInputText from 'component/Input/CustomInputDarkText';
import CryptoInput from 'component/Input/CryptoInput';
import CategoryPills from 'component/Input/CategoryPills';
import PurchaseLocationPills from 'component/Input/PurchaseLocationPills';
import { addCrypto } from 'api/crypto';

import { set_message } from 'redux/reducer/message';
import { getATH_ATL,getCategory } from 'api/crypto';
import FormateCurrency from 'utils/FormateCurrency';
import { useSelector,useDispatch } from 'react-redux';
import { mycoin } from 'api/crypto';
import { set_crypto } from 'redux/reducer/crypto';
import FormatToIntCurrency from 'utils/FormatToIntCurrency';
import { fireCoinConfetti } from 'utils/fireCoinConfetti';

const modalSx = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '92%',
    maxWidth: { xs: 410, sm: 480, md: 680 },
    maxHeight: { md: '90vh' },
    overflowY: { md: 'auto' },
    margin: 'auto',
    bgcolor: 'primary.light',
    boxShadow: 24,
    color: 'common.white',
    p: { xs: 1.8, md: 2.2 },
    borderRadius: 3,
    marginBottom: 50,
};





export default function AddCrypto({ refresh, visible, setVisble, selectedCoin, setSelectedCoin,setQuery }) {
    const [open, setOpen] = React.useState(visible);
    const [data, setData] = React.useState({ ATH: "", ATL: '',symbol:selectedCoin,qty:"",avg_buy:"" });
    const [category, setCategory] = React.useState(null);
    const [key, setkey] = React.useState(0);
    const [err, setErr] = React.useState(null);
    const dispatch = useDispatch();
    const { plan } = useSelector(state => state.user);
    const categories=useSelector(state=>state.crypto.category)
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        setOpen(visible);
    }, [visible]);

    React.useEffect(() => {
        setErr(null);
    }, [data.symbol])

    const handleClose = () => {
        setOpen(false);
        setVisble(false);
        setErr(null)
        setkey(Math.random())
        if (setSelectedCoin) {
            setSelectedCoin(null);
        }
    }

    const handleChange = (e) => {
        if(['category','symbol','notes','exchange'].includes(e.target.name)){
            setData(prev => ({ ...prev, [e.target.name]: e.target.value }));
        }else{
           if(!isNaN(parseFloat(e.target.value))){
            setData(prev => ({ ...prev, [e.target.name]: e.target.value }));
           }
          return e.preventDefault();
        }
       
    }

   
    const fetchData =React.useCallback(async () => {
        mycoin()
            .then(res => {
                //setCrypto(res.data?.data?.[0]?.assets||[])
                dispatch(set_crypto(res.data?.data?.[0]?.assets||[]))
               // res.data.total_data[0]&&setTotal(res.data.total_data[0])
            })
    }, [])

    const Update_ATL_ATH=(symbol)=>{
        getATH_ATL(symbol)
        .then(res=>{
          const {ATH,ATL,PRICE}=res.data;
          if(!PRICE){
            setErr('Sorry we are not able to receive info for this coin')
          }
          setData(prev=>({...prev,ATH:ATH||'',ATL:ATL||'',PRICE}))
        })
      }

    const hasPositiveNumber = (value) => {
        const parsed = parseFloat(value);
        return value !== '' && value != null && Number.isFinite(parsed) && parsed > 0;
    };

    const canSave = React.useMemo(() => {
        const symbol = data.symbol || selectedCoin;
        const categoryValue = plan?.name === 'Pro'
            ? (data.category || category)
            : (data.category || 'Goldv2');

        return Boolean(
            symbol
            && hasPositiveNumber(data.qty)
            && hasPositiveNumber(data.avg_buy)
            && categoryValue
            && data.exchange
        );
    }, [data, selectedCoin, category, plan?.name]);

    const saveButtonSx = {
        color: '#fff',
        borderColor: '#fff',
        borderRadius: '20px',
        textTransform: 'capitalize',
        '&.Mui-disabled': {
            color: 'rgba(255,255,255,0.35)',
            borderColor: 'rgba(255,255,255,0.25)',
        },
    };

    const handleSubmit = (e) => {
        let is_adding_another=e.nativeEvent.submitter.id=='add-another'
        e.preventDefault();
        if(loading || !canSave)return;
        if(selectedCoin){
            data.symbol=selectedCoin;
        }
        if(plan&& plan.name!=='Pro'){
           data.category='Goldv2';
        }
        setLoading(true);
        addCrypto(data)
            .then(res => {
                fireCoinConfetti();
                dispatch(set_message('Coin added'))
                if(!is_adding_another){
                    setVisble(false);
                }
               
                setData({});
                setkey(Math.random())
                if(setQuery){
                    setQuery('')
                }
                if(!is_adding_another){
                    setTimeout(() => {
                        if(window.location.pathname.includes('main')){
                            return fetchData();
                        }
                        refresh ? refresh() :(window.location.pathname.includes('all-coin')|| window.location.reload());
                    }, 2000)
                }
            })
            .catch(err => {
                setErr(err?.response?.data?.errorMessage?.[0] ||
                    err?.response?.data?.msg || 'Ooops! Something went wrong!')
            })
            .finally(() => setLoading(false))
    }

    React.useEffect(()=>{
        if(plan&& plan.name!=='Pro'){
            setData(prev=>({...prev,category:'Goldv2'}))
        }
    },[plan])


    React.useEffect(()=>{
        if(selectedCoin){
            Update_ATL_ATH(selectedCoin)
            getCategory(selectedCoin)
            .then((res)=>{
                setCategory(res.data.category);
                setData(prev=>({...prev,category:res.data.category}))
            })
        }
    },[selectedCoin])

    return (
        <Modal
            keepMounted
            open={open}
            onClose={handleClose}
            aria-labelledby="keep-mounted-modal-title"
            aria-describedby="keep-mounted-modal-description"
        >
            <Box key={key} component='form' onSubmit={handleSubmit} sx={modalSx}>
                <IconButton
                    type="button"
                    onClick={handleClose}
                    aria-label="Close add coin modal"
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        zIndex: 1,
                        color: '#fff',
                        p: 0.5,
                        '&:hover': { bgcolor: 'transparent', opacity: 0.75 },
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <Box sx={{ marginBottom: 1, marginTop: 2, textAlign: 'center' }}>
                      <Box sx={{display:'flex',alignItems:'center',flexDirection:'column'}}>
                            {selectedCoin && <><img src={`https://lcw.nyc3.cdn.digitaloceanspaces.com/production/currencies/64/${selectedCoin?.toLowerCase()}.png`} /> <br/><br/></>} 
                            <Typography sx={{color:'#fff',ml:2}} variant='h6'>ADD {selectedCoin?.replaceAll('_', '')}</Typography>
                            <Typography sx={{color:'#fff',mt:2}}>{data.price?`Current Price : ${FormatToIntCurrency(data?.price)}`:""}</Typography>
                            {/* <Typography sx={{color:'#fff',ml:2}} variant='h8'>Currently trading around {data?.PRICE && FormateCurrency(data.PRICE)} </Typography>
                            <Typography sx={{color:'#fff',ml:2}} variant='h8'>Currently trading around {data?.PRICE && FormateCurrency(data.PRICE)} </Typography> */}
                     
                     </Box>
                </Box>
                <Box>
                    {err && <Typography sx={{ color: 'red', textAlign: 'center',mb:2 }}>{err}</Typography>}
                    {!selectedCoin  &&
                     
                        <Box id="addCoinSearch">
                        <CryptoInput defaultCoin={selectedCoin} setData={setData} sx={{ mt: 2 }} />
                        </Box>
                    }
                    <CustomInput id="addCoinQty" onChange={handleChange} inputMode="numeric" value={data.qty} name='qty' sx={{ mt: 2 }} label='Quantity' />
                    <CustomInput id="addCoinAvgBuy" onChange={handleChange} inputMode="numeric" value={data.avg_buy} name='avg_buy' sx={{ mt: 2 }} label='Average Buy' />
                   {plan?.name=='Pro' &&
                    <CategoryPills
                       id="addCoinCategory"
                       onChange={handleChange}
                       value={data.category||category}
                       readOnly={Boolean(category)}
                       name='category'
                       label='Select Category*'
                       centered
                       option={categories.map(({name,_id})=>({value:name, label:name}))}
                   />
                   }
                   <PurchaseLocationPills
                       id="addCoinExchange"
                       onChange={handleChange}
                       value={data.exchange}
                       name='exchange'
                       label='Purchased at*'
                   />
                   <CustomInputText value={data.notes} onChange={handleChange} type="text" name='notes' sx={{ mt: 2 }} label='Add Notes' optional />
                </Box>
                <Box sx={{ width: '100%', height: 1.1, background: '#fff', marginTop: 3 }} />
                <Box sx={{ paddingTop: 3 ,fontSize:10,justifyContent:'space-between',display:'flex'}}>
                   {!selectedCoin && (
                    <Button
                      id='add-another'
                      type='submit'
                      variant="outlined"
                      disabled={!canSave || loading}
                      sx={saveButtonSx}
                    >
                      Save & Add
                    </Button>
                   )}
                    <Box sx={{ ml: 'auto', display: 'flex', gap: 1 }}>
                    <Button
                      id="addCoinSave"
                      type='submit'
                      variant="outlined"
                      disabled={!canSave || loading}
                      sx={saveButtonSx}
                    >
                      {loading ? 'Saving...' : 'Save'}
                    </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
}


// sx={{border:"1px solid #fff"}} labelStyle={{background:'black',padding:'0px 5px'}} style={{color:'#fff'}} 